import { combineReducers } from "redux";
import dashboards from "./dashboards";
import registrations from "./registrations";
import users from "./users";
import groupPermissions from "./groupPermissions";
import outages from "./outages";
import usersPagination from "./usersPagination";
import acrOutages from "./acrOutages";
import capturedChannels from "./capturedChannels";
import acrQueries from "./acrQueries";

const reducers = {
  dashboards,
  registrations,
  users,
  groupPermissions,
  outages,
  usersPagination,
  acrOutages,
  capturedChannels,
  acrQueries
};

const createReducer = injectedReducers => {
  return combineReducers({
    ...reducers,
    ...injectedReducers
  });
};

export default createReducer;
